(ns frontend.ui.component.lp-portal.report.company.net-debt-chart.view
  (:require
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]))

(defn net-debt-chart-card
  [net-debt props]
  [card
   {:title "Net debt"}
   [:<>
    [chart net-debt props]
    (text-content/optional-footnote net-debt props)]])
